import { rangeWithFallbackBounds } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_VALUATION = 0;
const DEFAULT_MAX_VALUATION = Number.MAX_SAFE_INTEGER;

export const valuationDescriptor = defineFilter({
  definition: {
    id: FilterId.VALUATION,
    name: 'Valuation',
    type: FilterType.RANGE,
    min: undefined,
    max: undefined,
    isActive: false,
    isVisible: true,
  },
  handler: rangeWithFallbackBounds(
    DEFAULT_MIN_VALUATION,
    DEFAULT_MAX_VALUATION
  ),
});
